import './loading-rocket.css';
import { t } from '@avalara/bat-apps-shared/i18n';
import conf from '../../conf';

const LoadingRocket = () => (
  <div className='container'>
    <img
      alt={t('client.accessibility.loading-rocket')}
      className='rocket animated'
      src={`${conf.ASSET_PATH}/assets/images/rocket/ship-ignited.svg`}
    />
    <img alt='stars' className='stars' src={`${conf.ASSET_PATH}/assets/images/rocket/stars.svg`} />
    <div className='land-container'>
      <img alt='land' src={`${conf.ASSET_PATH}/assets/images/rocket/land.png`} />

      <img alt='land' className='land2' src={`${conf.ASSET_PATH}/assets/images/rocket/land.png`} />
    </div>
  </div>
);

export default LoadingRocket;
